<template>

  <div class="headerArea">

    <!--<transition-group
      appear
      enter-active-class="animated fadeInDown"
      leave-active-class="animated slideOutUp"
    >-->

      <div class="hd_wrap" :class="{ 'absolute-top': fixed }" key="COMMON">

        <div class="top">
          <div class="inner">
            <!--<div class="tour">
              <span>Poker Tour</span>
              <a class="brand" target="_blank" href="https://www.wsop.com"><img src="/statics/img/logo_wsop.png" alt="WSOP" title="WSOP"></a>
              <a class="brand" target="_blank" href="https://www.worldpokertour.com"><img src="/statics/img/logo_wpt.png" alt="WPT" title="WPT"></a>
              <a class="brand" target="_blank" href="https://www.pokerstarslive.com/ept"><img src="/statics/img/logo_ept.png" alt="EPT" title="EPT"></a>
              <a class="brand" target="_blank" href="https://www.theasianpokertour.com"><img src="/statics/img/logo_apt.png" alt="APT" title="APT"></a>
              <a class="brand" target="_blank" href="https://asiapokerarena.com"><img src="/statics/img/logo_ctp.png" alt="CTP" title="CTP"></a>
              <a class="brand" target="_blank" href="https://useriespoker.com"><img src="/statics/img/logo_usop.png" alt="USOP" title="USOP"></a>
              <a class="brand" target="_blank" href="https://triton-series.com"><img src="/statics/img/logo_triton.png" alt="TRITON" title="TRITON"></a>
              <a class="brand" target="_blank" href="https://pokerdream-live.com"><img src="/statics/img/logo_pd.png" alt="Poker Dream" title="Poker Dream"></a>
              <a class="brand" target="_blank" href="https://www.pokerstarslive.com/appt"><img src="/statics/img/logo_appt.png" alt="APPT" title="APPT"></a>
              <a class="brand" target="_blank" href="https://www.acepokerleague.com"><img src="/statics/img/logo_apl.png" alt="APL" title="APL"></a>
              <a class="brand" target="_blank" href="https://www.ksop.co.kr"><img src="/statics/img/logo_ksop.png" alt="KSOP" title="KSOP"></a>
              <a class="brand" target="_blank" href="https://japanopenpoker.com"><img src="/statics/img/logo_jopt.png" alt="JOPT" title="JOPT"></a>
              <a class="brand" target="_blank" href="https://wptevent.jp"><img src="/statics/img/logo_wpt_japan.png" alt="WPT Japan" title="WPT Japan"></a>
              <a class="brand" target="_blank" href="https://aspt.world"><img src="/statics/img/logo_aspt.png" alt="ASPT" title="ASPT"></a>
            </div>-->
            <div class="lang">
              <p>eng</p>
              <ul class="drop-con">
                <li><a href="javascript:" class="on">english</a></li>
                <li><a href="javascript:" @click="gotoSite('KR')">korean</a></li>
              </ul>
              <img src="/statics/img/lang_eng.png">
            </div>
          </div>
        </div>
        <div class="bi">
          <router-link to="/home">Bluff &amp; <i>Catch</i><em>Poker News and Live Tournaments</em></router-link>
          <!--<nav class="bi_gnb">
            <ul>
              <li :class="{on : isCurrentGNB('news') && !isCurrentGNB('news/cate/2') || isCurrentGNB('article')}"><router-link to="/news">news</router-link></li>
              <li :class="{on : isCurrentGNB('tournaments') || isCurrentGNB('tournament')}"><router-link to="/tournaments" >tournaments</router-link></li>
              <li :class="{on : isCurrentGNB('news/cate/2')}"><router-link to="/news/cate/2" >poll</router-link></li>
              <li :class="{on : isCurrentGNB('ranking')}"><router-link to="/ranking">ranking</router-link></li>
            </ul>
          </nav>
          <header-search-area :heightSize="fixed ? 'small' : ''" class="bi_sch"/>-->
        </div>
        <div class="lang">
          <p @click="gotoSite('KR')">kr</p>
          <p class="on">en</p>
          <!--<ul class="drop-con">
            <li><a href="javascript:" class="on">english</a></li>
            <li><a href="javascript:" @click="gotoSite('KR')">korean</a></li>
          </ul>
          <img src="/statics/img/lang_eng.png">-->
        </div>
        <div class="inner">
          <nav class="hd_gnb">
            <ul>
              <!--<li :class="{on : isCurrentGNB('news/cate/1')}"><router-link to="/news/cate/1">wsop</router-link></li>-->
              <li :class="{on : isCurrentGNB('news') && !isCurrentGNB('news/cate/2') && !isCurrentGNB('news/cate/138') || isCurrentGNB('article') && !isCurrentGNB('reporting/article')}" @mouseleave="outside" @mouseover="openNewsMenuDropdown">
                <router-link to="/news" class="depth1">news</router-link>
                <div class="depth2 news" v-show="dropdown.news">
                  <router-link class="item" to="/news">Latest News</router-link>
                  <router-link class="item" to="/news/cate/10">Interviews</router-link>
                </div>
              </li>
              <!--<li :class="{on : isCurrentGNB('events') || isCurrentGNB('reporting')}"><router-link to="/events">live events</router-link></li>-->
              <li :class="{on : isCurrentGNB('tournaments') || isCurrentGNB('tournament') || isCurrentGNB('timeline')}" @mouseleave="outside" @mouseover="openTnmtMenuDropdown">
                <router-link to="/tournaments" class="depth1">tournaments</router-link>
                <div class="depth2 tnmt" v-show="dropdown.tnmt">
                  <router-link class="item" to="/tournaments">Schedule</router-link>
                  <router-link class="item" to="/timeline">Timeline</router-link>
                </div>
              </li>
              <!--<li :class="{on : isCurrentGNB('gallery')}"><router-link to="/gallery" >gallery</router-link></li>-->
              <li :class="{on : isCurrentGNB('market')}"><router-link to="/market">infographic</router-link></li>
              <li :class="{on : isCurrentGNB('training') || isCurrentGNB('news/cate/138')}"><router-link to="/training" >training</router-link></li>
              <!--<li :class="{on : isCurrentGNB('ranking')}"><router-link to="/ranking">ranking</router-link></li>-->
              <!--<li :class="{on : isCurrentGNB('poll')}"><router-link to="/poll" >poll</router-link></li>-->
              <li><a href="https://gosty-us.imweb.me/bluffcatch" target="_blank">shop</a></li>
              <header-search-area :heightSize="fixed ? 'small' : ''" />
            </ul>
          </nav>
        </div>
        <!--<div class="live">
          <div class="inner">
            <router-link to="/events" class="title">Upcoming Events</router-link>
            <router-link to="/tournament/174" class="">USOP Da Nang</router-link>
            <router-link to="/tournament/160" class="">APT Hanoi</router-link>
            <router-link to="/tournament/130" class="">WPT WC</router-link>
            <router-link to="/tournament/161" class="">WSOPP</router-link>
            <router-link to="/tournament/119" class="">EPT Prague</router-link>
          </div>
        </div>-->
      </div>
      <display-container :section="110" class="top_events"></display-container>
    <!--</transition-group>-->

  </div>
</template>
<script>
  import Vue from 'vue'
  import {QCarousel, QCarouselControl, QCarouselSlide, QDialog, QBtn} from 'quasar'
  import DisplayContainer from './DisplayContainer'
  import {Dialog, Popover, Dropdown, DropdownMenu, DropdownItem} from 'element-ui'
  import HeaderSearchArea from './HeaderSearchArea'
  import DropDown from '../components/Dropdown'
	import { mapGetters } from 'vuex'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  export default {
    name: "HeaderBar",
    components: {
      HeaderSearchArea,
      QCarousel, QCarouselControl, QCarouselSlide, QDialog, QBtn, DisplayContainer,
      [Dialog.name]: Dialog,
      [Popover.name]: Popover,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      DropDown
    },
    props: {
      fixed: {
        default: false,
        type: Boolean
      },
      topOffset: {
        default: 0,
        type: Number
      },
      direction: {
        default: 'down',
        type: String
      }
    },
    data () {
      return {
        env: 'pc',
        dropdown: {
          news: false,
          tnmt: false,
        },
        slide: 1,
        keyword: '',
        searchVisible: false,
        loaded: false,
        headerTopPosition: {
          'Home': 500,
          'ContentsDetail': 500,
					'Contents': 500,
        },
        layerBanner: {
          open: false,
          click: false
        },
      }
    },
    watch: {
      '$route' (to, from) {
        if (to.name !== 'SearchAll') {
          this.searchVisible = false
          this.keyword = ''
        }
      }
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'getCurrentContentsData'
      ]),
      getQueryKeyword () {
        return this.$route.query.keyword ? this.$route.query.keyword : ''
      },
      isDirectionDown () {
        return this.direction === 'down'
      },
      isLoadedDisplayData () {
        const rtn = this.$store.getters.getDisplayDataCnt
        if (rtn > 10) {
          this.openToastBanner()
          this.openExtendBanner()
          this.openLayerBanner()
        }
        return rtn > 10
      },
    },
    methods: {
      ...CommonMethods,
      isCurrentGNB (name) {
        return this.$route.path.indexOf(name) > -1
      },
      isCurrentRouteParamsView (name) {
        return this.$route.params.view === name
      },
      isCurrentRouteName (name) {
        return this.$route.name === name
      },
      isHeaderVisible (name) {
        // console.log(this.headerTopPosition[name], this.topOffset, this.headerTopPosition[name] < this.topOffset)
        return this.isCurrentRouteName(name)
          && this.fixed
          && this.isDirectionDown
          && this.headerTopPosition[name] < this.topOffset
      },
      setSearchVisible () {
        if (this.searchVisible) {
          if (this.keyword !== '') {
            this.$router.push({path: '/search/all', query: {keyword: this.keyword}})
          } else {
            this.searchVisible = false
          }
        } else {
          this.searchVisible = true
          this.$nextTick(() => this.$refs.keyword.focus())
        }
      },
      openNewsMenuDropdown () {
        this.dropdown.news = true
        this.dropdown.tnmt = false
      },
      openTnmtMenuDropdown () {
        this.dropdown.news = false
        this.dropdown.tnmt = true
      },
			closeDropdown () {
        this.dropdown.news = false
        this.dropdown.tnmt = false
      },
      outside (e) {
        // console.log('out')
        if (this.dropdown.news) {
          return this.dropdown.news =  false
        } else if (this.dropdown.tnmt) {
          return this.dropdown.tnmt = false
        }
      },
      openLayerBanner () {
        if (!this.$cookies.isKey("closedLayerBanner") && !this.layerBanner.click) {
          setTimeout(function () {
            this.layerBanner.open = true
          }.bind(this), 4000)
        }
      },
      closeLayerBanner () {
        this.layerBanner.open = false
        this.layerBanner.click = true
        this.$cookies.set("closedLayerBanner", true, 60 * 30)
        this.$refs.layerBanner.$destroy()
      },
      clickLayerBanner () {
        this.closeLayerBanner ()
      },
    },
    directives: {
      'click-outside': {
        bind: function (el, binding, vNode) {
          // Provided expression must evaluate to a function.
          if (typeof binding.value !== 'function') {
            const compName = vNode.context.name
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
            if (compName) {
              warn += `Found in component '${compName}'`
            }
            console.warn(warn)
          }
          // Define Handler and cache it on the element
          const bubble = binding.modifiers.bubble
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e)
            }
          }
          el.__vueClickOutside__ = handler

          // add Event Listeners
          document.addEventListener('click', handler)
        },

        unbind: function (el, binding) {
          // Remove Event Listeners
          document.removeEventListener('click', el.__vueClickOutside__)
          el.__vueClickOutside__ = null
        }
      }
    }
  }
</script>

<style scoped>
  .headerArea {
    position: relative;
    z-index: 2001;
    min-width: 1270px;
  }
  .headerArea .hd_wrap {
    background: #000;
  }
  .headerArea .hd_wrap .top {
    display: none;
    background: #202020;
  }
  .headerArea .hd_wrap .top .inner {
    display: flex;
    align-items: center;
    height: 50px;
  }
  .headerArea .hd_wrap .top .tour span {
    display: inline-block;
    font-size: 12px;
    font-weight: 600;
    color: rgba(255,255,255,0.5);
    padding-right: 15px;
    line-height: 34px;
  }
  .headerArea .hd_wrap .top .tour a {
    display: inline-block;
    padding: 5px 15px;
  }
  .headerArea .hd_wrap .top .tour a img {
    height: 24px;
    transition: .1s;
  }
  .headerArea .hd_wrap .top .tour a:hover img {
    transform: scale(130%);
  }
  .headerArea .hd_wrap .lang {
    font-family: 'SUIT Variable';
    position: absolute;
    top: 35px;
    right: 40px;
    transform: translate(0,-50%);
    display: inline-flex;
    height: 60px;
    align-items: center;
    cursor: pointer;
    z-index: 3;
  }
  .headerArea .hd_wrap .lang:hover .drop-con {
    display: block;
  }
  .headerArea .hd_wrap .lang p {
    display: inline-block;
    font-size: 12px;
    font-weight: 900;
    color: #888;
    display: inline-flex;
    align-items: center;
    text-transform: uppercase;
    margin-left: 12px;
  }
  .headerArea .hd_wrap .lang p.on {
    color: #fff;
  }
  .headerArea .hd_wrap .lang p:hover {
    color: #00ff64;
  }
/*
  .headerArea .hd_wrap .lang p:after {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg) translate(0,-20%);
    margin-left: 8px;
    margin-right: 18px;
  }
*/
  .headerArea .hd_wrap .lang .drop-con {
    display: none;
    position: absolute;
    top: 55px;
    background: #282828;
    padding: 10px 15px;
    line-height: 1.0em;
  }
  .headerArea .hd_wrap .lang .drop-con a {
    font-size: 12px;
    font-weight: 900;
    color: #999;
    text-transform: uppercase;
    display: inline-block;
    padding: 5px 0 5px 15px;
  }
  .headerArea .hd_wrap .lang .drop-con a.on {
    color: #fff;
  }
  .headerArea .hd_wrap .lang .drop-con a.on:before {
    content: "";
    display: inline-block;
    width: 5px;
    height: 8px;
    border: solid #fff;
    border-width: 0 1px 1px 0;
    transform: rotate(45deg) translate(0,-20%);
    position: absolute;
    margin-top: 2px;
    left: 15px;
  }
  .headerArea .hd_wrap .lang .drop-con a:hover {
    color: #00ff64;
  }
  .headerArea .hd_wrap .lang img {
    height: 32px;
  }
  .headerArea .hd_wrap .bi {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 120px;
    transition: .15s;
  }
  .headerArea .hd_wrap .bi a {
    font-family: 'Spectral';
    font-weight: 400;
    font-size: 64px;
    color: #fff;
    letter-spacing: -0.07em;
    line-height: 1.0em;
    transition: .15s;
  }
  .headerArea .hd_wrap .bi a i {
    color: #00ff64;
  }
  .headerArea .hd_wrap .bi a em {
    display: block;
    font-family: 'Rokkitt';
    font-size: 18px;
    font-style: normal;
    letter-spacing: 0.0em;
    line-height: 1.0em;
    transition: .15s;
  }
  .headerArea .hd_wrap .bi .bi_gnb,
  .headerArea .hd_wrap .bi .bi_sch {
    display: none;
  }
  .headerArea .hd_gnb {
    border-top: 1px solid rgba(255,255,255,0.2);
    height: 60px;
    line-height: 56px;
    text-align: center;
  }
  .headerArea .hd_gnb > ul > li {
    position: relative;
    display: inline-block;
    height: 60px;
  }
  .headerArea .hd_gnb > ul > li > a {
    font-family: 'Roboto Slab';
    font-size: 20px;
    font-weight: 800;
    color: #fff;
    letter-spacing: 0.02em;
    padding: 14px 24px;
    text-transform: capitalize;
    transition: .1s;
    position: relative;
  }
  .headerArea .hd_gnb > ul > li > a.depth1:before {
    content: "";
    display: inline-block;
    position: absolute;
    right: 8px;
    top: 51%;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    border-top: 4px solid #999;
  }
  .headerArea .hd_gnb > ul > li:first-child > a {
    /*padding-left: 0;*/
  }
  .headerArea .hd_gnb > ul > li.new > a:after {
    content: "";
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 100%;
    background: #00b404;
    position: absolute;
    top: 30%;
    margin-left: 3px;
  }
  .headerArea .hd_gnb > ul > li:hover > a {
    color: #00ff64;
  }
  .headerArea .hd_gnb > ul > li.on > a:after {
    content: "";
    display: inline-block;
    width: calc(100% - 48px);
    height: 2px;
    background: #00ff64;
    position: absolute;
    left: 24px;
    bottom: 11px;
  }
  .headerArea .hd_gnb > ul > li:first-child.on a:after {
    /*width: calc(100% - 24px);
    left: 0;*/
  }
  .headerArea .hd_gnb > ul > li .depth2 {
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translate(-50%, 0);
    display: inline-block;
    background: #000;
    line-height: 1.0em;
    padding: 0 15px 10px;
    z-index: 5;
  }
  .headerArea .hd_gnb > ul > li .depth2 .item {
    display: block;
    min-width: 140px;
    font-family: 'Roboto Slab';
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    padding: 15px 0;
    border-bottom: 1px solid #333;
  }
  .headerArea .hd_gnb > ul > li .depth2 .item:last-child {
    border-bottom: 0;
  }
  .headerArea .hd_gnb > ul > li .depth2 .item:hover {
    color: #00ff64;
  }
  .headerArea .top_events /deep/ a {
    pointer-events: none;
  }
  .headerArea .ad_wrap {
    margin: 40px auto;
    text-align: center;
  }
  .headerArea .hd_search {
    float: left;
    position: relative;
    z-index: 2;
  }
  .headerArea .hd_search .sch_btn {
    display: block;
    width: 60px;
    height: 80px;
    font-size: 0;
    text-indent: -9999px;
    background: url('/statics/img/hd_search_icon.png') no-repeat center center;
    transition: all 0.2s;
    cursor: pointer;
  }
  .headerArea .hd_search .sch_box {
    display: none;
    position: absolute;
    left: -280px;
    top: 0;
    width: 280px;
    height: 80px;
    background: #243745;
  }
  .headerArea .hd_search .sch_box input {
    width: 100%;
    height: 80px;
    padding: 0 20px;
    font-size: 18px;
    font-weight: 600;
    font-style: italic;
    color: rgba(255, 255, 255, 0.5);
    border: 0;
  }
  .headerArea .hd_search .sch_box input::-webkit-input-placeholder {
    color: #000;
  }
  .headerArea .hd_search .sch_box input:-moz-placeholder {
    color: #6f7a82;
  }
  .headerArea .hd_search .sch_box input::-moz-placeholder {
    color: #6f7a82;
  }
  .headerArea .hd_search .sch_box input:-ms-input-placeholder {
    color: #6f7a82;
  }
  .headerArea .hd_search.on .sch_box {
    display: block;
  }
  .headerArea .hd_wrap /deep/ .display-container .router-link-active {
    pointer-events: none;
  }
  .headerArea /deep/ .live {
    width: 1220px;
    margin: 0 auto;
    transition: .15s;
    text-align: left;
  }
  .headerArea /deep/ .live:after {
    content: "";
    display: block;
    width: 100%;
    height: 1px;
    background: #ccc;
  }
  .headerArea /deep/ .live .inner {
    display: flex;
    height: 50px;
    align-items: center;
    padding: 0;
  }
  .headerArea /deep/ .live .inner p {
    display: inline-block;
    line-height: 1.0em;
  }
  .headerArea /deep/ .live .title {
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    background: linear-gradient(to right, #603afe, #fc0192);
    padding: 6px 10px;
    display: inline-block;
    border-radius: 4px;
    border-right: 0;
  }
  .headerArea /deep/ .live .title:hover {
    color: #fff;
  }
  .headerArea /deep/ .live .title:after {
    content: "▶";
    font-size: 6px;
    color: #fff;
    margin-left: 6px;
  }
  .headerArea /deep/ .live a {
    font-size: 13.5px;
    font-weight: 400;
    color: #000;
    padding: 0 18px;
    border-right: 1px solid rgba(0,0,0,0.15);
    pointer-events: all;
    letter-spacing: 0em !important;
  }
  .headerArea /deep/ .live a sup {
    font-weight: 300;
    line-height: 2.6em;
    margin-left: 3px;
  }
  .headerArea /deep/ .live a:hover {
    color: #008c03;
  }
  .headerArea /deep/ .live p:last-child a {
    border: 0;
  }
  .headerArea /deep/ .live a.now:after {
    content: "NOW";
    font-size: 10px;
    font-weight: 900;
    color: #00ff64;
    position: relative;
    top: -5px;
    left: 5px;
  }
  .headerArea /deep/ .live a.upcoming:after {
    content: "Upcoming";
    font-size: 10px;
    font-weight: 900;
    color: #00ff64;
    position: relative;
    top: -5px;
    left: 5px;
  }
  .headerArea /deep/ .live a.ongoing:after {
    content: "Ongoing";
    font-size: 10px;
    font-weight: 900;
    color: #00ff64;
    position: relative;
    top: -5px;
    left: 5px;
  }
  .headerArea /deep/ .live a.end {
    opacity: 0.65;
  }

  /* floating */
  .headerArea.fixed .hd_wrap {
    z-index: 10;
  }
  .headerArea.fixed .hd_wrap .bi {
    height: 60px;
  }
  .headerArea.fixed .hd_wrap .bi > a {
    font-size: 32px;
    /*position: absolute;
    left: 20px;*/
  }
  .headerArea.fixed .hd_wrap .bi a em {
    font-size: 11px;
  }
  .headerArea.fixed .hd_wrap .bi .bi_gnb {
    display: inline-block;
    position: absolute;
    left: 220px;
  }
  .headerArea.fixed .hd_wrap .bi .bi_gnb li {
    display: inline-block;
  }
  .headerArea.fixed .hd_wrap .bi .bi_gnb a {
    font-family: 'Roboto Slab';
    font-size: 20px;
    font-weight: 900;
    line-height: 1.0em;
    letter-spacing: 0.05em;
    color: #fff;
    padding: 0 25px;
    text-transform: uppercase;
  }
  .headerArea.fixed .hd_wrap .bi .bi_gnb li.on a {
    color: #00ff64;
  }
  .headerArea.fixed .hd_wrap .top,
  .headerArea.fixed .hd_wrap .live,
  .headerArea.fixed .hd_wrap > .inner {
    height: 0;
    overflow: hidden;
  }
  .headerArea.fixed .hd_wrap .bi .bi_sch {
    display: block;
    position: absolute;
    right: 0;
  }
  .headerArea.fixed .hd_wrap h1 img {
    /*margin-top: -10px;*/
		height: 60px;
  }
  .headerArea.fixed .hd_wrap .lang {
    top: 30px;
  }
  .headerArea.fixed .hd_gnb > ul > li > a {
    height: 60px;
    line-height: 58px;
  }
  .headerArea.fixed .hd_gnb > ul > li.on > a:before {
    top: 55px;
  }
  .headerArea.fixed .hd_gnb .depth2 {
    top: 60px;
  }
  .headerArea.fixed .hd_slide {
    height: 60px;
  }
  .headerArea.fixed .slide_lst {
    height: 60px;
  }
  .headerArea.fixed .slide_lst a p {
    height: 60px;
  }
  .headerArea.fixed .live_ranking .tit {
    height: 60px;
  }
  .headerArea.fixed .hd_search .sch_btn {
    height: 60px;
    background-position: center;
  }
  .headerArea.fixed .hd_search .sch_box {
    height: 60px;
  }
  .headerArea.fixed .hd_search .sch_box input {
    height: 60px;
  }


  /* 상단 고정 - 공통 */
  .fixmenu_wrap {
    width: 100%;
    height: 60px;
    background: #000;
    z-index: 2001;
    position: relative;
  }
  .fixmenu_wrap .fixmenu_con {
    width: 880px;
    height: 60px;
    display: inline-table;
  }
  .fixmenu_wrap .fixmenu_con div {
    display: table-cell;
    vertical-align: middle;
    width: 100%;
    height: 60px;
    color: #fff;
    text-align: center;
    position: relative;
  }
  .fixmenu_wrap .hd_slide {
    float: left;
    position: relative;
    z-index: 1;
    width: 280px;
    height: 60px;
    background: #243745;
  }
  .fixmenu_wrap .hd_search {
    float: left;
    position: relative;
    z-index: 2;
  }
  .fixmenu_wrap .hd_search .sch_btn {
    display: block;
    width: 60px;
    height: 60px;
    font-size: 0;
    text-indent: -9999px;
    background: url('/statics/img/hd_search_icon.png') no-repeat center center;
    transition: all 0.2s;
  }

  /* 상단 고정 - 차트 */
  .fixmenu_wrap .fixmenu_con .chart {
    font-size: 28px;
    font-weight: 700;
    letter-spacing: -0.05em;
  }
  .fixmenu_wrap .fixmenu_con .chart .cal_btn {
    cursor: pointer;
  }
  .fixmenu_wrap .fixmenu_con .chart .cal_btn i {
    font-family: "Oswald";
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0em;
    border-bottom: 1px solid #fff;
    position: absolute;
    margin-top: 6px;
    left: 0;
  }
  .fixmenu_wrap .fixmenu_con .chart .cal_btn i:after {
    display: inline-block;
    position: absolute;
    right: -20px;
    top: 50%;
    width: 12px;
    height: 8px;
    margin-top: -2px;
    background: url('/statics/img/gnb_arr_down.png');
    content: "";
  }
  .fixmenu_wrap .fixmenu_con .chart .chart_select_btn {
    font-size: 14.5px;
    font-weight: 700;
    background: #ffa800;
    border-radius: 100px;
    padding: 4px 19px 5px;
    position: absolute;
    margin-top: 6px;
    margin-left: 20px;
    cursor: pointer;
  }
  .fixmenu_wrap .fixmenu_con .chart .chart_select_btn:hover {
    background: #dc473a;
  }

  /* 상단 고정 - 콘텐츠 */
  .fixmenu_wrap .fixmenu_con .contents {
    text-align: left;
  }
  .fixmenu_wrap .fixmenu_con .contents .con_title {
    display: inline-block;
    max-width: 840px;
    height: 22px;
    font-size: 20px;
    line-height: 18px;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .fixmenu_wrap .fixmenu_con .contents .con_title i {
    font-size: 14px;
    color: #ffa800;
    margin-right: 20px;
  }

  /* 상단 고정 - 비교 */
  .compare {
    height: 90px;
    background: #fff;
    z-index: 2001;
    position: relative;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  }
  .compare .inner {
    display: table;
    width: 100%;
  }
  .compare .compare_box {
    position: relative;
    display: table-cell;
    width: 33.333%;
    padding: 10px 0 10px 20px;
  }
  .compare .compare_box li {
    display: table-cell;
    vertical-align: middle;
  }
  .compare .compare_box li.img {
    width: 70px;
    height: 70px;
    background: #efefea;
    border-radius: 100%;
    text-align: center;
  }
  .compare .compare_box li.img img {
    max-width: 100%;
    max-height: 100%;
  }
  .compare .compare_box li.img.empty {
    background: #efefea url('/statics/img/compare_choice_bg_small.png') center no-repeat;
    cursor: pointer;
  }
  .compare .compare_box li.txt {
    padding-left: 15px;
    font-size: 15px;
    font-weight: 700;
    color: #222;
    letter-spacing: -0.03em;
  }
  .compare .compare_box li.txt span {
    display: block;
    font-size: 14px;
    font-weight: 400;
    color: #777;
  }
  .compare .compare_box li.txt.empty {
    color: #777;
  }

  /* 상단 고정 - TEAM */
  .fixmenu_wrap .fixmenu_con .team {
    font-size: 28px;
    font-weight: 700;
    letter-spacing: -0.05em;
  }
  .fixmenu_wrap .fixmenu_con .team .team_select_btn {
    display: inline-block;
    position: relative;
    cursor: pointer;
    top: 3px;
    left: 14px;
    width: 35px;
    height: 35px;
    background: #ffa800 url(/statics/img/arr_down_white.png) no-repeat 50%;
    transition: all .15s;
  }
  .fixmenu_wrap .fixmenu_con .team .team_select_btn:hover {
    background: #f35c55 url(/statics/img/arr_down_white.png) no-repeat 50%;
  }

  .sticker {
    display: inline-block;
    width: 400px;
    height: 60px;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    text-align: center;
    line-height: 60px;
    background: #ffa800;
    border-radius: 2.0em;
    box-shadow: 0 10px 10px rgba(0,0,0,0.2);
    position: absolute;
    top: 75px;
    left: 50%;
    transform: translate(-50%, 0);
    transition: 0.2s;
  }

  /* 카드사 모달 */
  .crop_choice_pop {
    position: relative;
    width: 600px;
    padding: 30px 30px 24px;
    text-align: center;
    background: #fff;
  }
  .crop_choice_pop .tit {
    line-height: 30px;
    font-size: 24px;
    color: #000;
    letter-spacing: -0.5px;
    font-weight: 600;
  }
  .crop_choice_pop .tit:before {
    display: block;
    width: 60px;
    height: 60px;
    margin: 0 auto 15px;
    background: #ffa800 url('/statics/img/crop_choice_pop.png');
    border-radius: 100%;
    content: "";
  }
  .crop_choice_pop .lst {
    min-height: 180px;
    max-height: 300px;
    margin-top: 26px;
    overflow-y: auto;
    background: #f5f5f5;
  }
  .crop_choice_pop .lst a {
    display: block;
    cursor: pointer;
    line-height: 60px;
    font-size: 16px;
    color: #222;
    transition: all 0.15s;
  }
  .crop_choice_pop .lst .on a,
  .crop_choice_pop .lst a:hover {
    background: #eaeaea;
  }
  .crop_choice_pop .txt {
    display: inline-block;
    line-height: 27px;
    margin-top: 22px;
    padding-left: 25px;
    font-size: 15px;
    color: #999;
    background: url('/statics/img/icon_exclamation.png') no-repeat left center;
  }
  .crop_choice_pop .close_btn {
    position: absolute;
    right: 30px;
    top: 30px;
    cursor: pointer;
    width: 30px;
    height: 30px;
    font-size: 0;
    text-indent: -9999px;
    background: url('/statics/img/close_01.png');
  }
	.con-scr {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 320px;
		background: #000;
		display: block;
		text-align: center;
		padding: 30px 30px;
	}
	.con-scr p {
		font-size: 17px;
		line-height: 16px;
		color: #fff;
		font-weight: 400;
		margin-bottom: 20px;
	}
	.con-scr a {
		display: block;
		width: 100%;
		padding: 12px;
		background: #ffa800;
		font-size: 16px;
		font-weight: 700;
		color: #fff;
		transition: 0.2s;
	}
	.con-scr a:hover {
		background: #fb4c3c;
	}
	/* on wallpaper */
	.wallpaper .headerArea .hd_wrap {

  }
	.wallpaper .headerArea .hd_wrap /deep/ .live .inner {
    max-width: unset;
		padding: 0;
  }
	.wallpaper .headerArea .hd_wrap .bi {

  }
  .wallpaper .headerArea .hd_wrap .bi a {

  }
  .wallpaper .headerArea .hd_wrap .bi a i {

  }
  .wallpaper .headerArea .hd_wrap .bi a em {

  }
  .wallpaper .headerArea .top_events {
    background: #fff;
  }
  /deep/ [data-f-id="pbf"] {
    display: none;
  }
</style>
